var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { getCardboardBoxWorldFootprint, getRotatedFootprint, } from "./pallet";
/*
 * The raycast this replaces widened the sampled footprint by 2% of the cup
 * width, so a cup teetering exactly on a box edge counts as outside. Kept for
 * parity.
 */
var cupEdgeMarginFactor = 0.02;
/*
 * Half-extents of the smallest axis-aligned rectangle containing an ellipse
 * with radii (rx, rz) rotated by θ about Y: along X it is
 * √((rx·cosθ)² + (rz·sinθ)²), and symmetrically along Z.
 */
export var rotatedEllipseHalfExtents = function (rx, rz, rotationY) {
    var theta = (rotationY * Math.PI) / 180;
    var cos = Math.cos(theta);
    var sin = Math.sin(theta);
    return {
        x: Math.hypot(rx * cos, rz * sin),
        z: Math.hypot(rx * sin, rz * cos),
    };
};
/* The cup's rotated footprint, edge margin included. */
export var cupHalfExtents = function (cup) {
    var margin = cup.width * cupEdgeMarginFactor;
    return rotatedEllipseHalfExtents(cup.width / 2 + margin, cup.depth / 2 + margin, cup.rotationY);
};
/*
 * The box (among `boxes`) whose top face the whole cup footprint sits over, or
 * `undefined` when the cup is outside every box or straddles two — a cup must
 * grip a single box, so a straddling cup counts as missing the object, exactly
 * as the raycast it replaces did.
 *
 * `objectSize` is the size every box shares; a box with a size of its own uses
 * that instead (see `getCardboardBoxWorldFootprint`).
 */
export var findCupTargetBox = function (cup, boxes, objectSize) {
    var e_1, _a;
    var extents = cupHalfExtents(cup);
    try {
        for (var boxes_1 = __values(boxes), boxes_1_1 = boxes_1.next(); !boxes_1_1.done; boxes_1_1 = boxes_1.next()) {
            var box = boxes_1_1.value;
            var footprint = getRotatedFootprint(getCardboardBoxWorldFootprint(box, objectSize), box.rotation);
            var dx = Math.abs(cup.center.x - box.position.x);
            var dz = Math.abs(cup.center.z - box.position.z);
            if (dx <= footprint.x / 2 - extents.x &&
                dz <= footprint.z / 2 - extents.z) {
                // Boxes don't overlap, so full containment in one box is exclusive —
                // the first match is the only possible match.
                return box.id;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (boxes_1_1 && !boxes_1_1.done && (_a = boxes_1.return)) _a.call(boxes_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return undefined;
};
